import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	RouterStateSnapshot,
	UrlTree,
	Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { IS_NULL_OR_UNDEFINED } from 'cargo-chief-commons';

@Injectable({
	providedIn: 'root',
})
export class PublicPageGuard implements CanActivate {
	constructor(
		private cargoChief: Cargochief,
		private router: Router
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const isUserLoggedOut: boolean = IS_NULL_OR_UNDEFINED(this.cargoChief.USER_ID);
		if (isUserLoggedOut) {
			return true;
		}
		const queryParamsToForward = {};
		const BATCH_ID_QUERY = 'batchId';
		if (route.queryParamMap.has(BATCH_ID_QUERY)) {
			queryParamsToForward[BATCH_ID_QUERY] = route.queryParamMap.get(BATCH_ID_QUERY);
		}
		return this.router.createUrlTree(['/carriers/availableLoads'], {
			queryParams: queryParamsToForward,
		});
	}
}
